import { storageFactory } from '@/calendesk/tools/storageFactory'

export const local = storageFactory(() => localStorage)
export const session = storageFactory(() => sessionStorage)
